import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './BottomCTA.css';

const BottomCTA = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`bottom-cta ${isVisible ? 'bottom-cta--visible' : ''}`}
    >
      <div className="bottom-cta__container">
        <div className="bottom-cta__content">
          <h2 className="bottom-cta__title">
            Ready to accelerate your research?
          </h2>
          <p className="bottom-cta__subtitle">
            Join thousands of researchers who are already collaborating, publishing, and discovering on ResearchPro.
          </p>
          <div className="bottom-cta__actions">
            <Link to="/register" className="bottom-cta__btn bottom-cta__btn--primary">
              Get Started Free
              <ArrowRight size={16} />
            </Link>
            <Link to="/features" className="bottom-cta__btn bottom-cta__btn--secondary">
              Explore Features
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomCTA;
